var _rect, _g, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2402_3146",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2402_3146)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H23V23H0V0Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.91699V3.83366H23V1.91699H0ZM0 5.75033V7.66699H23V5.75033H0ZM0 11.5003V9.58366H23V11.5003H0ZM0 13.417V15.3337H23V13.417H0ZM0 19.167V17.2503H23V19.167H0ZM0 23.0003V21.0837H23V23.0003H0Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12.9375,
    height: 13.4167,
    fill: "#2E42A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.49497 4.16651L2.25673 3.45901L2.84763 4.02622H2.51306L3.18965 4.82412L2.96113 5.94288H2.60321L2.25566 4.91536L1.95927 5.94288H1.07556L1.75215 6.74079L1.49497 7.99985L2.25673 7.29234L2.84763 7.85955H2.51306L3.18965 8.65745L2.96113 9.77622H2.60321L2.25566 8.7487L1.95927 9.77622H1.07556L1.75215 10.5741L1.49497 11.8332L2.25673 11.1257L2.99378 11.8332L2.76463 10.5741L3.35655 9.77622H3.08352L3.69423 9.20901L4.28513 9.77622H3.95056L4.62715 10.5741L4.36997 11.8332L5.13173 11.1257L5.86878 11.8332L5.63963 10.5741L6.23155 9.77622H5.95852L6.56923 9.20901L7.16013 9.77622H6.82556L7.50215 10.5741L7.24497 11.8332L8.00673 11.1257L8.74378 11.8332L8.51463 10.5741L9.10655 9.77622H8.83352L9.44423 9.20901L10.0351 9.77622H9.70056L10.3771 10.5741L10.12 11.8332L10.8817 11.1257L11.6188 11.8332L11.3896 10.5741L11.9815 9.77622H11.2282L10.8807 8.7487L10.5843 9.77622H10.1557L9.95213 8.65745L10.544 7.85955H10.271L10.8817 7.29234L11.6188 7.99985L11.3896 6.74079L11.9815 5.94288H11.2282L10.8807 4.91536L10.5843 5.94288H10.1557L9.95213 4.82412L10.544 4.02622H10.271L10.8817 3.45901L11.6188 4.16651L11.3896 2.90745L11.9815 2.10955H11.2282L10.8807 1.08203L10.5843 2.10955H9.70056L10.3771 2.90745L10.1486 4.02622H9.79071L9.44316 2.9987L9.14677 4.02622H8.71825L8.51463 2.90745L9.10655 2.10955H8.35321L8.00566 1.08203L7.70927 2.10955H6.82556L7.50215 2.90745L7.27363 4.02622H6.91571L6.56816 2.9987L6.27177 4.02622H5.84325L5.63963 2.90745L6.23155 2.10955H5.47821L5.13066 1.08203L4.83427 2.10955H3.95056L4.62715 2.90745L4.39863 4.02622H4.04071L3.69316 2.9987L3.39677 4.02622H2.96825L2.76463 2.90745L3.35655 2.10955H2.60321L2.25566 1.08203L1.95927 2.10955H1.07556L1.75215 2.90745L1.49497 4.16651ZM10.1486 7.85955L10.3771 6.74079L9.70056 5.94288H10.0351L9.44423 5.37568L8.83353 5.94288H9.10655L8.51463 6.74079L8.71825 7.85955H9.14677L9.44316 6.83203L9.79071 7.85955H10.1486ZM8.59763 7.85955L8.00673 7.29234L7.39603 7.85955H7.66905L7.07713 8.65745L7.28075 9.77622H7.70927L8.00566 8.7487L8.35321 9.77622H8.71113L8.93965 8.65745L8.26306 7.85955H8.59763ZM6.06465 8.65745L5.83613 9.77622H5.47821L5.13066 8.7487L4.83427 9.77622H4.40575L4.20213 8.65745L4.79405 7.85955H4.52103L5.13173 7.29234L5.72263 7.85955H5.38806L6.06465 8.65745ZM6.27177 7.85955H5.84325L5.63963 6.74079L6.23155 5.94288H5.95853L6.56923 5.37568L7.16013 5.94288H6.82556L7.50215 6.74079L7.27363 7.85955H6.91571L6.56816 6.83203L6.27177 7.85955ZM4.39863 7.85955L4.62715 6.74079L3.95056 5.94288H4.28513L3.69423 5.37568L3.08353 5.94288H3.35655L2.76463 6.74079L2.96825 7.85955H3.39677L3.69316 6.83203L4.04071 7.85955H4.39863ZM8.93965 4.82412L8.71113 5.94288H8.35321L8.00566 4.91536L7.70927 5.94288H7.28075L7.07713 4.82412L7.66905 4.02622H7.39603L8.00673 3.45901L8.59763 4.02622H8.26306L8.93965 4.82412ZM5.72263 4.02622L5.13173 3.45901L4.52103 4.02622H4.79405L4.20213 4.82412L4.40575 5.94288H4.83427L5.13066 4.91536L5.47821 5.94288H5.83613L6.06465 4.82412L5.38806 4.02622H5.72263Z",
    fill: "#F7FCFF"
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "url(#paint0_linear_2402_3146)",
    style: {
      mixBlendMode: "overlay"
    }
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "black",
    strokeOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2402_3146",
    x1: 11.5,
    y1: 0,
    x2: 11.5,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsd);
export default __webpack_public_path__ + "static/media/USD.e67bf580309019d52cbd3b3b62f436f9.svg";
export { ForwardRef as ReactComponent };